import Swiper, {
  Autoplay,
  Pagination,
  EffectFade,
  Navigation,
} from 'swiper';

Swiper.use([Autoplay, Pagination, EffectFade, Navigation]);

class LogoCarousel {
  static init() {
    const carousels = document.querySelectorAll('.logo-carousel');
  
    carousels.forEach((carousel) => {
      /* eslint-disable no-new */
      new Swiper(carousel, {
        slidesPerView: 1,
        centeredSlides: true,
        loop: true,
        loopAdditionalSlides: 2, // prevent display of end of loop
        allowTouchMove: true,
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
          dynamicBullets: true,
          dynamicMainBullets: 3,
        },
        breakpoints: {
          560: {
            slidesPerView: 2,
            centeredSlides: false,
            spaceBetween: 32,
          },
          992: {
            slidesPerView: 4,
            centeredSlides: false,
            spaceBetween: 32,
          },
        },
      });
    });
    /* eslint-enable no-new */
  }
}

document.addEventListener('DOMContentLoaded', () => {
  LogoCarousel.init();
});
